/**
 * Subeader.jsx
 * Created by michaelbray on 7/12/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    headerClass: PropTypes.string,
    subheaderItems: PropTypes.array
};

const defaultProps = {
    headerClass: "header-primary",
    subheaderItems: []
};

export default class Subeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            buttons: []
        };
    }

    componentWillMount() {
        this.generateButtons(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.subheaderItems !== this.props.subheaderItems) {
            this.generateButtons(nextProps);
        }
    }

    generateButtons(props) {
        const buttons = props.subheaderItems.map((item) => (
            <button className="rec-filters-btn" key={item.title}>
                {item.leftIcon}
                {item.title}
                {item.rightIcon}
            </button>
        ));

        this.setState({
            buttons
        });
    }

    render() {
        return (
            <header
                role="menu"
                tabIndex={0}
                className={`header-filters-container ${this.props.headerClass}`}>
                <div className="header-filters">
                    {this.state.buttons}
                </div>
            </header>
        );
    }
}

Subeader.propTypes = propTypes;
Subeader.defaultProps = defaultProps;
